import getBrowserFingerprint from 'get-browser-fingerprint'

export const getBrowserFingerprintData = ()=>{
    return getBrowserFingerprint();
}